<script setup lang="ts">
/*
 * Animated loading placeholder block. Exposes width/height as props so
 * pages can scaffold their own loading UI (rows, cards, KPIs) before data
 * arrives.
 */
withDefaults(
  defineProps<{
    width?: string;
    height?: string;
    rounded?: 'sm' | 'md' | 'lg' | 'pill' | 'full';
  }>(),
  { width: '100%', height: '1rem', rounded: 'md' },
);

const radiusMap = {
  sm: 'rounded-sm',
  md: 'rounded-md',
  lg: 'rounded-lg',
  pill: 'rounded-pill',
  full: 'rounded-full',
} as const;
</script>

<template>
  <span
    :class="['block animate-pulse bg-slate-200', radiusMap[rounded]]"
    :style="{ width, height }"
    aria-hidden="true"
  />
</template>
